/**
 * Model zur Auswertung der Aufgaben
 * @class service_v3sExercise
 * @memberOf v3sWbtPlayerApp:model
 */
angular.module('v3sWbtPlayerApp').factory('v3sExercise', ["$rootScope", "v3sExerciseStatus", "v3sServiceFinder", function ($rootScope, v3sExerciseStatus, v3sServiceFinder) {
    var v3sFeedbackService = v3sServiceFinder.get("v3sFeedbackService");

    var v3sExercise = function (page, data) {

        this.page = page;

        this.type = "";
        this.instantMode = false;
        this.maxAttempts = 1;
        this.minAnswers = 1;

        this.elements = [];
        this.attempts = 0;
        this.status = v3sExerciseStatus.NO_ANSWER;
        this.completed = false;
        this.generalFeedbackVisible = true;

        if (!!data) {
            angular.extend(this, data);
        }

        this.notifyExerciseChanged();
    };

    /**
     * Gibt den Aufgabentyp zurück
     * @memberOf v3sWbtPlayerApp:model.service_v3sExercise
     * @returns {string} Aufgabentyp
     */
    v3sExercise.prototype.getType = function () {
        return this.type;
    };


    /**
     * Gibt die Schwierigkeit zurück, falls vorhanden
     * @memberOf v3sWbtPlayerApp:model.service_v3sExercise
     * @returns {string} Schwierigkeit
     */
    v3sExercise.prototype.getDifficulty = function () {
        return this.difficulty || null;
    };

    /**
     * Fügt ein Aufgaben-Element zu der Auswertung hinzu
     * @memberOf v3sWbtPlayerApp:model.service_v3sExercise
     * @param {v3sWbtPlayerApp:exercise.service_v3sExerciseElement} exerciseElement - Aufgaben-Element
     */
    v3sExercise.prototype.addExerciseElement = function (exerciseElement) {
        this.elements.push(exerciseElement);
    };

    /**
     * Gibt alle Aufgaben-Elemente zurück
     * @memberOf v3sWbtPlayerApp:model.service_v3sExercise
     */
    v3sExercise.prototype.getExerciseElements = function () {
        return this.elements;
    };

    /**
     * Aktualisiert die Aufgabe nach dem ein Element verändert wurde
     * @memberOf v3sWbtPlayerApp:model.service_v3sExercise
     * @param {v3sWbtPlayerApp:exercise.service_v3sExerciseElement} exerciseElement - Aufgaben-Element
     */
    v3sExercise.prototype.updateExerciseElement = function (exerciseElement) {
        if (v3sFeedbackService && !exerciseElement.isAnswerAutoRemoved()) {
            v3sFeedbackService.hideFeedback();
        }
        
        this.updateStatus();
        if (this.instantMode) {
            this.evaluate({ exerciseElement: exerciseElement });
        } else {
            this.notifyExerciseChanged();
        }
    };

    /**
     * Gibt die Element-Daten letzter Auswertung zurück
     * @memberOf v3sWbtPlayerApp:model.service_v3sExercise
     * @param {v3sWbtPlayerApp:exercise.service_v3sExerciseElement} exerciseElement - Aufgaben-Element
     */
    v3sExercise.prototype.getExerciseElementData = function (exerciseElement) {
        return null;  
    };

    /**
     * Setzt die Element-Daten letzter Auswertung
     * @memberOf v3sWbtPlayerApp:model.service_v3sExercise
     * @param {v3sWbtPlayerApp:exercise.service_v3sExerciseElement} exerciseElement - Aufgaben-Element
     */
    v3sExercise.prototype.setExerciseElementData = function (exerciseElement, data) {
    };

    v3sExercise.prototype.setLastAttempt = function () {
        this.attempts = this.maxAttempts;
    };
 
    /**
     * Wertet die Aufgabe aus
     * @memberOf v3sWbtPlayerApp:model.service_v3sExercise
     */
    v3sExercise.prototype.evaluate = function (options) {
        if (!this.completed) {
            options = options || {};

            if (!!options.failedIfNoAnswer) {
                this.setLastAttempt();
            }

            if (!!options.exerciseElement) { // Sofortauswertung
                if (options.exerciseElement.getStatus().incorrect || this.status === v3sExerciseStatus.CORRECT) {
                    this.attempts++;
                }
            } else if (this.status != v3sExerciseStatus.NO_ANSWER && this.attempts < this.maxAttempts) {
                this.attempts++;
            }

            if (this.attempts === this.maxAttempts || this.status === v3sExerciseStatus.CORRECT) {
                this.complete(options);

                if (this.status == v3sExerciseStatus.NO_ANSWER && !!options.failedIfNoAnswer) {
                    this.status = v3sExerciseStatus.FALSE;
                }
            }

            this.showFeedback(options.exerciseElement, !!options.timeout);
            this.notifyExerciseChanged();
        }
    };

    /**
     * Zeigt den Feedback {@link v3sWbtPlayerApp:exercise.service_v3sFeedbackService v3sFeedbackService}
     * @memberOf v3sWbtPlayerApp:model.service_v3sExercise
     */
    v3sExercise.prototype.showFeedback = function (exerciseElement, timeout) {

        if (v3sFeedbackService && (!!this.generalFeedbackVisible || !this.isAnswered()) && (this.completed || !exerciseElement || exerciseElement.getStatus().incorrect)) {
            v3sFeedbackService.hideFeedback();
            v3sFeedbackService.showFeedback(this.status, this.type, this.completed, this.maxAttempts - this.attempts, timeout);
        }

        if (!this.completed && !!exerciseElement) {
            exerciseElement.showFeedback();
        }
    };

    /**
     * Schließt die Auswertung ab und aktualisiert den Status und Score der Seite
     * @memberOf v3sWbtPlayerApp:model.service_v3sExercise
     */
     //TODO:Sergius, last im Test vereinfachen.
    v3sExercise.prototype.complete = function (options) {
        if (!this.completed) {

            angular.forEach(this.elements, function (element) {
                element.complete(true);
            });

            if (this.status != v3sExerciseStatus.NO_ANSWER || this.attempts > 0) {
                this.completed = true;
                var score = this.status == v3sExerciseStatus.CORRECT ? 100 : 0;
                this.page.evaluate(score);
                this.page.complete();
            }
        }
    };

    /**
     * Räumt die Auswertung auf
     * @memberOf v3sWbtPlayerApp:model.service_v3sExercise
     */
    v3sExercise.prototype.clean = function () {
        if (v3sFeedbackService) v3sFeedbackService.hideFeedback();
        this.complete();
        this.elements = [];
    };

    /**
     * Gibt zurück, ob die Aufgabe abgeschlossen ist
     * @memberOf v3sWbtPlayerApp:model.service_v3sExercise
     * @return {bool} Aufgabe abgeschlossen
     */
    v3sExercise.prototype.isCompleted = function () {
        return this.completed;
    };

    /**
     * Gibt zurück, ob Benutzer die Aufgabe korrekt bearbeitet hat
     * @memberOf v3sWbtPlayerApp:model.service_v3sExercise
     * @return {bool} Aufgabe abgeschlossen
     */
    v3sExercise.prototype.isPassed = function () {
        return this.isCompleted() && this.status == v3sExerciseStatus.CORRECT;
    };

    /**
     * Gibt zurück, ob Benutzer die Aufgabe bearbeitet hat
     * @memberOf v3sWbtPlayerApp:model.service_v3sExercise
     * @return {bool} Aufgabe abgeschlossen
     */
    v3sExercise.prototype.isAnswered = function () {
        return this.status != v3sExerciseStatus.NO_ANSWER;
    };

    /**
     * Gibt zurück, ob die Auswertung der Aufgabe sichtbar ist
     * @memberOf v3sWbtPlayerApp:model.service_v3sExercise
     * @return {bool} Auswertung der Aufgabe ist/wird sichtbar
     */
    v3sExercise.prototype.isExerciseEvaluationVisible = function () {
        return true;
    };

    /**
     * Gibt zurück, ob die globalen Einstellung zur Navigation ignoriert werden sollen.
     * @memberOf v3sWbtPlayerApp:model.service_v3sExercise
     * @return {bool} ob die Einstellung ignoriert werden soll
     */
    v3sExercise.prototype.isIgnoreNavigationSetting = function () {
        return false;
    };

    /**
     * Berechnet und aktualisiert den Status der Aufgabe
     * @memberOf v3sWbtPlayerApp:model.service_v3sExercise
     * @return {@link v3sWbtPlayerApp:exercise.constant_v3sExerciseStatus v3sExerciseStatus} Aufgabenstatus
     */
    v3sExercise.prototype.updateStatus = function () {
        var exerciseStatus = v3sExerciseStatus.NO_ANSWER;

        if (!!this.elements && this.elements.length > 0) {
            var noAnswer = 0;
            var correctAnswer = 0;
            var wrongAnswer = 0;
            var maxCorrectAnswers = 0;

            angular.forEach(this.elements, function (element) {
                var status = element.getStatus();
                if (element.hasCorrectAnswer()) {
                    maxCorrectAnswers++;
                }
                switch (status) {
                    case element.STATUS.CORRECT:
                        correctAnswer++;
                        break;
                    case element.STATUS.FALSE:
                    case element.STATUS.FALSE_ABOVE:
                    case element.STATUS.FALSE_BELOW:
                        wrongAnswer++;
                        break;
                    default:
                        noAnswer++;
                }
            });

            if (this.elements.length - noAnswer >= this.minAnswers) {
                if (correctAnswer == maxCorrectAnswers) {
                    if (wrongAnswer == 0) {
                        exerciseStatus = v3sExerciseStatus.CORRECT;
                    } else {
                        exerciseStatus = v3sExerciseStatus.ALL_CORRECT_AND_FALSE;
                    }
                } else if (wrongAnswer == 0) {
                    exerciseStatus = v3sExerciseStatus.CORRECT_NOT_ALL;
                } else if (wrongAnswer > 0 && correctAnswer > 0) {
                    exerciseStatus = v3sExerciseStatus.CORRECT_AND_FALSE;
                } else {
                    exerciseStatus = v3sExerciseStatus.FALSE;
                }
            }
        }

        this.status = exerciseStatus;
    };

    /**
      * Erzeugt einen Event beim Ändern der Aufgabe
      * @memberOf v3sWbtPlayerApp:model.service_v3sExercise
      * @emits v3sExerciseChanged
      */
    v3sExercise.prototype.notifyExerciseChanged = function () {
        $rootScope.$emit('v3sExerciseChanged');
    };

    return v3sExercise;
}]);
